//
// Overwrite the scroll position to adjust that the .is-selected row is always positioned below the fixed table header.
//

document.addEventListener("livewire:init", function() {
    setTimeout(scrollToSelectedElement, 100);
});

function scrollToSelectedElement() {
    let selectedElement = document.querySelector('.table-fixed .is-selected');

    if (selectedElement) {
        let tableResponsive = selectedElement.closest('.table-responsive');

        if (tableResponsive) {
            tableResponsive.scrollTop = selectedElement.offsetTop - 50;
        }
    }
}
